import triggerTracking from '@blueprint/tracking';

const EVENT = 'GAEvent';
const CATEGORY = 'listing details';

export const trackExpandDescription = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'description',
        eventLabel: 'view more'
    });
};

export const trackContractDescription = () => {
    triggerTracking({
        event: EVENT,
        eventCategory: CATEGORY,
        eventAction: 'description',
        eventLabel: 'view less'
    });
};
